import { IAsyncDropdownModel } from "common/models/IDropdownModel";
import { z } from "zod";

export const IssueReportsSchema = z
  .object({
    materialAccessionNoID: z.string().nullish(),
    accessionNoValue: z.custom<IAsyncDropdownModel>().optional(),
    admissionYearID: z.string().nullish(),
    memberID: z.string().nullish(),
    memberCodeValue: z.custom<IAsyncDropdownModel>().optional(),
    instituteID: z.string().nullish(),
    memberInstituteID: z.string().nullish(),
    departmentID: z.string().nullish(),
    memberDepartmentID: z.string().nullish(),
    memberTypeID: z.string().nullish(),
    materialTypeID: z.string().nullish(),
    fromDate: z.coerce
      .string()
      .refine((c) => c !== "null", { message: "Select From Date" })
      .refine(
        (value) => {
          return !isNaN(Date.parse(value));
        },
        { message: "Invalid date" },
      ),
    toDate: z.coerce
      .string()
      .refine((c) => c !== "null", { message: "Select To Date" })
      .refine(
        (value) => {
          return !isNaN(Date.parse(value));
        },
        { message: "Invalid date" },
      ),
    filterRadioBtn: z.coerce.number({
      message: "Select One",
      required_error: "Select One",
    }),
    libRadioBtn: z.coerce.number({
      message: "Select One",
      required_error: "Select One",
    }),
  })
  .superRefine((data, ctx) => {
    if (data.fromDate && data.toDate) {
      const start = new Date(data.fromDate).getTime();
      const end = new Date(data.toDate).getTime();
      if (!isNaN(start) && !isNaN(end) && end < start) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "To Date must be after or equal to From Date",
          path: ["toDate"],
        });
      }
    }
  });

export type IIssueReports = z.infer<typeof IssueReportsSchema>;

export const MaterialReportsSchema = z.object({});
export type IMaterialReports = z.infer<typeof MaterialReportsSchema>;

export const MemberReportsSchema = z.object({
  programID: z.string().nullish(),
  instituteID: z.string().nullish(),
  departmentID: z.string().nullish(),
  memberStatusID: z.string().nullish(),
  memberTypeID: z.string().nullish(),
  admissionYearID: z.string().nullish(),
  filterRadioBtn: z.coerce.number({
    message: "Select One",
    required_error: "Select One",
  }),
  libRadioBtn: z.coerce.number({
    message: "Select One",
    required_error: "Select One",
  }),
  memberTypeRadioBtn: z.coerce.number({
    message: "Select One",
    required_error: "Select One",
  }),
});
export type IMemberReports = z.infer<typeof MemberReportsSchema>;

export const IssueReturnPerformanceReportsSchema = z
  .object({
    materialAccessionNoID: z.string().nullish(),
    accessionNoValue: z.custom<IAsyncDropdownModel>().optional(),
    admissionYearID: z.string().nullish(),
    memberID: z.string().nullish(),
    memberCodeValue: z.custom<IAsyncDropdownModel>().optional(),
    instituteID: z.string().nullish(),
    memberInstituteID: z.string().nullish(),
    departmentID: z.string().nullish(),
    memberDepartmentID: z.string().nullish(),
    memberTypeID: z.string().nullish(),
    materialTypeID: z.string().nullish(),
    fromDate: z.coerce
      .string()
      .refine((c) => c !== "null", { message: "Select From Date" })
      .refine(
        (value) => {
          return !isNaN(Date.parse(value));
        },
        { message: "Invalid date" },
      ),
    toDate: z.coerce
      .string()
      .refine((c) => c !== "null", { message: "Select To Date" })
      .refine(
        (value) => {
          return !isNaN(Date.parse(value));
        },
        { message: "Invalid date" },
      ),
    filterRadioBtn: z.coerce.number({
      message: "Select One",
      required_error: "Select One",
    }),
    libRadioBtn: z.coerce.number({
      message: "Select One",
      required_error: "Select One",
    }),
  })
  .superRefine((data, ctx) => {
    if (data.fromDate && data.toDate) {
      const start = new Date(data.fromDate).getTime();
      const end = new Date(data.toDate).getTime();
      if (!isNaN(start) && !isNaN(end) && end < start) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "To Date must be after or equal to From Date",
          path: ["toDate"],
        });
      }
    }
  });

export type IIssueReturnPerformanceReports = z.infer<
  typeof IssueReturnPerformanceReportsSchema
>;
